import actions from './actions'
import getters from './getters'
import mutations from './mutations'

export default {
  namespaced: true,
  state: () => ({
    type: '', // os tipos são: debito, credito e multiplo
    brand: '',
    requestingInfos: false,
    selectedCardType: 'credito', // usando somente para o shopify
  }),
  mutations,
  actions,
  getters,
}
